import React, { useEffect, useState } from "react";
import "./styles.scss";
import { Col, Container, Row } from "react-bootstrap";
// import { BarLoader } from "react-spinners";
import UserNotification from "../../../../../../shared/components/Notification/UserNotification";
import { Country } from "../../../../../../shared/constants/Constant";
import PageHeader from "../../../../components/page-header/PageHeader";
import { GoCalendar } from "react-icons/go";
import ReactDatePicker from "react-datepicker";
import moment from "moment";
import { useFunctions, useStorage } from "reactfire";
import FormValidator from "../../../../../../shared/utils/FormValidator";
import { FaPencilAlt } from "react-icons/fa";
import ConfirmationModal from "../../../../../../shared/components/confirmationModal/ConfirmationModal";
import { useAppUser } from "../../../../../../contexts/user-context/UserContext";
import { useLocation } from "react-router-dom";
import { useWorkShop } from "../../../../../../contexts/workshop-context/WorkshopContext";
import random from "randomstring";

interface IState {
  title: string;
  description: string;
  points: string;
  startDate: Date;
  endDate: Date;
  country: Country;
  titleError: string;
  descriptionError: string;
  pointsError: string;
  startDateError: string;
  endDateError: string;
  loading: boolean;
  thumbnail: string;
  mode: "PREVIEW" | "EDIT";
}

const initialState: IState = {
  title: "",
  description: "",
  points: "",
  startDate: new Date(),
  endDate: new Date(),
  country: Country.SRI_LANKA,
  titleError: "",
  descriptionError: "",
  pointsError: "",
  startDateError: "",
  endDateError: "",
  loading: false,
  thumbnail: "",
  mode: "PREVIEW",
};

interface State {
  showAcceptConfirmation: boolean;
  showClearConfirmation: boolean;
  showRemoveConfirmation: boolean;
}

const initState: State = {
  showAcceptConfirmation: false,
  showClearConfirmation: false,
  showRemoveConfirmation: false,
};

const WorkshopSummary = () => {
  const creatRef = useFunctions().httpsCallable("updatePublicWorkshop");
  const gWrokshop_ = useWorkShop();
  const appUser = useAppUser();
  const editPath: boolean = useLocation().pathname.includes("/edit");
  const [state, setState] = useState(initialState);
  const [acceptencestate, setAcceptenceState] = useState(initState);
  const [dateArray, setDateArray] = useState<Date[]>([]);

  const [fileInput, setFileInput] = useState<any>(null);
  const [thumbnail, setThumbnail] = useState<{
    file: File | null;
    preview: any;
  }>({ file: null, preview: null });
  const storage = useStorage().ref();

  useEffect(() => {
    setState((ps) => ({
      ...ps,
      title: gWrokshop_.title,
      description: gWrokshop_.description,
      points: gWrokshop_.points.toString(),
      startDate: gWrokshop_.startDate,
      endDate: gWrokshop_.endDate,
      country: gWrokshop_.country,
      thumbnail: gWrokshop_.thumbnail,
      titleError: "",
      descriptionError: "",
      pointsError: "",
      startDateError: "",
      endDateError: "",
    }));
  }, [
    gWrokshop_.title,
    gWrokshop_.description,
    gWrokshop_.points,
    gWrokshop_.startDate,
    gWrokshop_.endDate,
    gWrokshop_.country,
    gWrokshop_.thumbnail,
    state.mode,
  ]);

  const updateWorkshop = () => {
    if (validateData()) {
      if (thumbnail.file) {
        setState((ps) => ({ ...ps, loading: true }));
        const uploadTask = storage
          .child(
            `publicworkshopthumbnails/${random.generate(
              10
            )}.${thumbnail?.file.name
              .split(".")
              .pop()
              ?.toLowerCase()}`
          )
          .put(thumbnail.file);
        uploadTask.on("state_changed", function(snapshot) {
          let progress = Math.round(
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100
          );
          console.log(progress);
        });
        uploadTask.then((snapshot) => {
          snapshot.ref.getDownloadURL().then((url) => {
            const reqData = {
              id: gWrokshop_.id,
              title: state.title,
              description: state.description,
              points: state.points,
              startDate: moment(state.startDate).format("MM/DD/YYYY"),
              endDate: moment(state.endDate).format("MM/DD/YYYY"),
              thumbnail: url,
            };
            creatRef(reqData)
              .then(() => {
                UserNotification({
                  isSuccess: true,
                  message: "Workshop updated",
                });
              })
              .catch(() => {
                UserNotification({
                  isSuccess: false,
                  message: "Workshop update failed!",
                });
              })
              .finally(() => {
                setAcceptenceState({
                  ...acceptencestate,
                  showAcceptConfirmation: false,
                });
                setState((ps) => ({ ...ps, loading: false, mode: "PREVIEW" }));
              });
          });
        });

        uploadTask.catch(() => {
          UserNotification({
            isSuccess: false,
            message: "Workshop update failed!",
          });
          setState((ps) => ({ ...ps, loading: false, mode: "PREVIEW" }));
        });
      } else {
        setState((ps) => ({ ...ps, loading: true }));
        const reqData = {
          id: gWrokshop_.id,
          title: state.title,
          description: state.description,
          points: state.points,
          startDate: moment(state.startDate).format("MM/DD/YYYY"),
          endDate: moment(state.endDate).format("MM/DD/YYYY"),
          thumbnail: "",
        };
        creatRef(reqData)
          .then(() => {
            UserNotification({
              isSuccess: true,
              message: "Workshop updated",
            });
          })
          .catch(() => {
            UserNotification({
              isSuccess: false,
              message: "Workshop update failed!",
            });
          })
          .finally(() => {
            setAcceptenceState({
              ...acceptencestate,
              showAcceptConfirmation: false,
            });
            setState((ps) => ({ ...ps, loading: false, mode: "PREVIEW" }));
          });
      }
    }
  };

  const validateData = (): boolean => {
    const wtValidation = FormValidator.validateString(
      state.title,
      "Workshop title",
      3,
      100
    );

    const sdValidation =
      state.startDate === null
        ? { message: "Please set a valid Start Date.", isValid: false }
        : { message: "", isValid: true };

    const pointsValidation = parseInt(state.points)
      ? {
          message: "",
          isValid: true,
        }
      : {
          message: "Please set a valid points.",
          isValid: false,
        };

    const edValidation =
      state.endDate === null ||
      state.endDate <= (state.startDate !== null ? state.startDate : new Date())
        ? { message: "Please set a valid End Date.", isValid: false }
        : { message: "", isValid: true };

    const wdValidation = FormValidator.validateString(
      state.description,
      "Workshop description",
      3,
      1000
    );

    setState({
      ...state,
      titleError: wtValidation.message,
      descriptionError: wdValidation.message,
      pointsError: pointsValidation.message,
      startDateError: sdValidation.message,
      endDateError: edValidation.message,
    });

    return (
      wtValidation.isValid &&
      wdValidation.isValid &&
      pointsValidation.isValid &&
      sdValidation.isValid &&
      edValidation.isValid
    );
  };

  const [showCalender, setShowCalender] = useState({
    startDate: false,
    endDate: false,
  });

  useEffect(() => {
    setThumbnail((ps) => ({ ...ps, preview: undefined }));
  }, [state.mode]);

  return (
    <>
      <PageHeader title="Workshop Summary" />

      <Container
        fluid
        className="workshop-summary-warapper"
        style={{
          paddingTop: "200px",
          paddingLeft: "50px",
          paddingRight: "50px",
          paddingBottom: "50px",
        }}
      >
        {state.mode === "PREVIEW" ? (
          (appUser.userRole.isAdmin || appUser.userRole.isModerator) &&
          editPath && (
            <Row>
              <Col xs={12} className="text-right p-0">
                <div
                  className="edit d-inline-block"
                  onClick={(e) => {
                    const tmp = [...dateArray];
                    tmp.push(state.startDate);
                    setDateArray(tmp);
                    setState({
                      ...state,
                      mode: "EDIT",
                    });
                  }}
                >
                  <FaPencilAlt /> <span>Edit</span>
                </div>
              </Col>
            </Row>
          )
        ) : (
          <Row>
            <Col xs={12} className="text-right">
              <button
                className="cancel-button blue"
                style={{ marginRight: "15px" }}
                onClick={() => {
                  !state.loading && setState({ ...state, mode: "PREVIEW" });
                }}
              >
                Cancel
              </button>
              <button
                className="save-button"
                style={{ marginLeft: "15px" }}
                onClick={() => {
                  validateData() &&
                    setAcceptenceState({
                      ...acceptencestate,
                      showAcceptConfirmation: true,
                    });
                }}
              >
                Save
              </button>
            </Col>
          </Row>
        )}
        {/*{state.loading && (*/}
        {/*  <Row className="mb-4">*/}
        {/*    <Col xs={12}>*/}
        {/*      <BarLoader*/}
        {/*        height={4}*/}
        {/*        width={"100%"}*/}
        {/*        color={"#006699"}*/}
        {/*        loading={state.loading}*/}
        {/*      />*/}
        {/*    </Col>*/}
        {/*  </Row>*/}
        {/*)}*/}
        <Row>
          <Col
            xs={12}
            className="text-left font-weight-bold"
            style={{ color: "rgb(7, 66, 94)", width: "100%" }}
          >
            {state.mode === "EDIT" && (
              <label style={{ color: "#505050", fontWeight: "bold" }}>
                Workshop Title{" "}
                <span className="ml-1" style={{ color: "red" }}>
                  *
                </span>
              </label>
            )}
            {state.mode === "EDIT" ? (
              <input
                value={state.title}
                onChange={(e) => setState({ ...state, title: e.target.value })}
                className={
                  state.titleError.length < 1
                    ? "app-input"
                    : "app-input invalid"
                }
              />
            ) : (
              <p className="workshop-title-preview">{state.title}</p>
            )}

            {state.mode === "EDIT" && (
              <label className="error-message">{state.titleError}</label>
            )}
          </Col>
        </Row>
        <Row>
          <Col
            xs={12}
            className="text-left font-weight-bold"
            style={{ color: "rgb(7, 66, 94)", width: "100%" }}
          >
            {state.mode !== "PREVIEW" ? (
              <>
                <label style={{ color: "#505050", fontWeight: "bold" }}>
                  Workshop Description{" "}
                  <span className="ml-1" style={{ color: "red" }}>
                    *
                  </span>
                </label>
                <textarea
                  style={{ minHeight: "200px" }}
                  className={
                    state.descriptionError.length < 1
                      ? "app-input"
                      : "app-input invalid"
                  }
                  onChange={(e) =>
                    setState({ ...state, description: e.target.value })
                  }
                  value={state.description}
                />
                <label className="error-message">
                  {state.descriptionError}
                </label>
              </>
            ) : (
              <p
                className="text-justify"
                style={{
                  width: "100%",
                  fontWeight: "normal",
                  paddingTop: "0px",
                  fontSize: "20px",
                  color: "#646464",
                }}
              >
                {state.description}
              </p>
            )}
          </Col>
        </Row>
        <Row
          className="pt-4"
          style={{ fontSize: "20px", color: "#646464", minHeight: "100px" }}
        >
          <Col xs={4}>
            <div>
              <label className="font-weight-bold">Start Date</label>
              <div className="date-input-preview">
                <label className="ml-2">
                  <ReactDatePicker
                    readOnly={state.mode === "PREVIEW"}
                    className={
                      state.mode === "EDIT"
                        ? "data-date-input-edit"
                        : "w-100 data-input-preview"
                    }
                    value={moment(state.startDate || new Date()).format(
                      "MM/DD/YYYY"
                    )}
                    onChange={(date: Date) => {
                      if (FormValidator.isDateInTheFuture(dateArray[0])) {
                        FormValidator.isDateInTheFuture(date) &&
                          setState({ ...state, startDate: date });
                      } else {
                        dateArray[0] &&
                          (FormValidator.areDatesEqual(date, dateArray[0]) ||
                            date > dateArray[0]) &&
                          setState({ ...state, startDate: date });
                      }
                    }}
                    open={showCalender.startDate}
                    onClickOutside={() =>
                      setShowCalender({
                        ...showCalender,
                        startDate: false,
                      })
                    }
                  />
                </label>
                <span
                  className="ml-2"
                  style={{ fontSize: "24px" }}
                  onClick={() => {
                    if (state.mode === "EDIT")
                      setShowCalender({
                        ...showCalender,
                        startDate: !showCalender.startDate,
                      });
                  }}
                >
                  <GoCalendar />
                </span>
              </div>
            </div>
            <div>
              {state.mode === "EDIT" && (
                <label className="error-message">{state.startDateError}</label>
              )}
            </div>
          </Col>
          <Col xs={4} className="text-center">
            <div>
              <label className="font-weight-bold">End Date</label>
              <div className="date-input-preview">
                <label className="ml-2">
                  <ReactDatePicker
                    readOnly={state.mode === "PREVIEW"}
                    value={moment(state.endDate || new Date()).format(
                      "MM/DD/YYYY"
                    )}
                    className={
                      state.mode === "EDIT"
                        ? "data-date-input-edit"
                        : "w-100 data-input-preview"
                    }
                    onChange={(date: Date) => {
                      setState({ ...state, endDate: date });
                    }}
                    open={showCalender.endDate}
                    onClickOutside={() =>
                      setShowCalender({
                        ...showCalender,
                        endDate: false,
                      })
                    }
                  />
                </label>
                <span
                  className="ml-2"
                  style={{ fontSize: "24px" }}
                  onClick={() => {
                    if (state.mode === "EDIT")
                      setShowCalender({
                        ...showCalender,
                        endDate: !showCalender.endDate,
                      });
                  }}
                >
                  <GoCalendar />
                </span>
              </div>
            </div>
            <div>
              {state.mode === "EDIT" && (
                <label className="error-message">{state.endDateError}</label>
              )}
            </div>
          </Col>
          <Col xs={4} className="points-center">
            <label className="font-weight-bold">Points</label>
            <input
              readOnly={state.mode === "PREVIEW"}
              type="number"
              onKeyDown={() => setState({ ...state, pointsError: "" })}
              onChange={(e) => setState({ ...state, points: e.target.value })}
              className="data-input-preview"
              style={{ width: "70px" }}
              value={state.points}
            />
            <div>
              {state.mode === "EDIT" && (
                <label className="error-message">{state.pointsError}</label>
              )}
            </div>
          </Col>
        </Row>
        <Row>
          {state.mode !== "PREVIEW" && (
            <Col xs={12} className="d-flex">
              <div
                style={{
                  width: "200px",
                  flexShrink: 0,
                  alignItems: "center",
                }}
              >
                <label
                  className="m-0"
                  style={{ color: "#505050", fontWeight: "bold" }}
                >
                  Thumbnail
                </label>
                <div className="mt-3">
                  <button
                    className="app-button-small"
                    onClick={() => fileInput?.click()}
                  >
                    Select an image
                  </button>
                  <input
                    ref={(input) => setFileInput(input)}
                    className="d-none"
                    type="file"
                    accept="image/*"
                    onChange={(e) => {
                      const files = e.target.files;
                      if (files) {
                        let reader = new FileReader();
                        let file = files[0];
                        reader.onloadend = () => {
                          setThumbnail({
                            preview: reader.result,
                            file: file,
                          });
                        };
                        reader.readAsDataURL(file);
                      }
                    }}
                  />
                </div>
              </div>

              <div className="d-flex justify-content-start">
                <img
                  src={thumbnail.preview ? thumbnail.preview : state.thumbnail}
                  alt=""
                  style={{ width: "200px" }}
                />
              </div>
            </Col>
          )}
        </Row>
        {acceptencestate.showAcceptConfirmation && (
          <ConfirmationModal
            loading={state.loading}
            children={{
              headerText: "Confirm Updates",
              bodyText: <>Are you sure you want to update the content?</>,
              cancelButtonText: "Cancel",
              confirmButtonText: "Update",
              confirmButtonColor: state.loading ? "grayStatic" : "blue",
            }}
            show={acceptencestate.showAcceptConfirmation}
            onCancel={() =>
              setAcceptenceState({
                ...acceptencestate,
                showAcceptConfirmation: false,
              })
            }
            onConfirm={() => {
              !state.loading && updateWorkshop();
            }}
          />
        )}
      </Container>
    </>
  );
};

export default WorkshopSummary;
